import { useTranslation } from 'react-i18next';
import ErrorBoundary from 'src/components/ErrorBoundary';
import Navbar from 'src/components/NavBar';
import useWindowSize from 'src/hooks/useWindowSize';
import CompanyTree from 'src/sections/work_area/CompanyTree';
import UserCompanies from 'src/sections/work_area/UserCompanies';
import { WorkAreaContextProvider } from 'src/sections/work_area/WorkAreaContext';
import WorkAreaHeader from 'src/sections/work_area/WorkAreaHeader';
import {
  useWorkAreaPanelsGridRef,
  workAreaPanelsGridClassName,
} from 'src/sections/work_area/workAreaPanelLayout';
import 'src/style/grid/grid-override.scss';

const WorkArea = () => {
  const { height } = useWindowSize();
  const { t } = useTranslation();
  const { panelsGridRef } = useWorkAreaPanelsGridRef();

  return (
    <ErrorBoundary>
      <WorkAreaContextProvider>
        <div
          className="flex flex-col overflow-hidden bg-white"
          style={{ height: height > 0 ? height : '100vh' }}
        >
          <Navbar title={t('Work Area')} />
          <WorkAreaHeader />
          <div ref={panelsGridRef} className={workAreaPanelsGridClassName}>
            <CompanyTree />
            <UserCompanies />
          </div>
        </div>
      </WorkAreaContextProvider>
    </ErrorBoundary>
  );
};

export default WorkArea;
